function ErrorDiv({ error = "", textCenter = false }) {
  return (
    <div className={"text-sm text-alert " + (textCenter ? "text-center" : "")}>
      {error}
    </div>
  );
}

export { ErrorDiv };
